import _ from "lodash"

// test: jest src/models/__tests__/BookingData.model.spec.js
export default class BookingData {
  constructor(rawData) {
    this._rawData = rawData;
  }

  // Factory method for creating from collection item
  // static fromArray(arrayItems) {
  //   return arrayItems.map(item => new BookingData(item));
  // }

  isArray() {
    return Array.isArray(this._rawData?.value)
  }

  isCollectionField() {
    if (this.isArray()) {
      return this._rawData?.value.some(item => ['collection_select', 'collection_carousel'].includes(_.get(item, 'type')))
    }

    return ['collection_select', 'collection_carousel'].includes(_.get(this._rawData?.value, 'type'))
  }

  // Read-only properties
  get booking_id() {
    return this._rawData?.booking_id
  }
  get field_id() {
    return this._rawData?.field_id
  }
  get title() {
    return this._rawData?.title
  }
  get value() {
    return this._rawData?.value
  }
}
